/**
 * Shipment type definitions used across the application
 */

export enum ShipmentType {
  OCEAN_FCL = 'FCL',
  OCEAN_LCL = 'LCL',
  AIR = 'AIR',
  TRUCK_LTL = 'LTL',
  TRUCK_FTL = 'FTL',
  RAIL = 'RAIL',
}

export const ShipmentTypeLabels: Record<ShipmentType, string> = {
  [ShipmentType.OCEAN_FCL]: 'Ocean FCL',
  [ShipmentType.OCEAN_LCL]: 'Ocean LCL',
  [ShipmentType.AIR]: 'Air',
  [ShipmentType.TRUCK_LTL]: 'Truck LTL',
  [ShipmentType.TRUCK_FTL]: 'Truck FTL',
  [ShipmentType.RAIL]: 'Rail',
}

/**
 * Check if a shipment type is ocean freight (FCL or LCL)
 */
export function isOceanFreight(shipmentType: string | undefined): boolean {
  return shipmentType === ShipmentType.OCEAN_FCL || shipmentType === ShipmentType.OCEAN_LCL
}

/**
 * Location type definitions
 */
export enum LocationType {
  PORT = 'Port',
  AIRPORT = 'Airport',
  DOOR = 'Door',
}

export const LocationTypeLabels: Record<LocationType, string> = {
  [LocationType.PORT]: 'Port',
  [LocationType.AIRPORT]: 'Airport',
  [LocationType.DOOR]: 'Door',
}
